const fileInputFields = document.querySelectorAll<HTMLElement>(".f-file");

fileInputFields.forEach(fileInputField => {
  const messageElement = fileInputField.querySelectorAll<HTMLElement>(".f-file__message")[0];
  const removeElement = fileInputField.querySelectorAll<HTMLElement>(".f-file__remove")[0];
  const defaultMessage = messageElement.textContent ?? "";
  const sizeError = fileInputField.parentElement.querySelector<HTMLElement>(".f-file__size-error");

  const input = fileInputField.querySelectorAll<HTMLInputElement>("input[type=file]")[0];

  input.form?.addEventListener('submit', () => {
    if (!fileInputField.classList.contains('--visible')) input.disabled = true;
    else input.disabled = false;
  })

  const preventDefault = (e : Event) => {
    if (fileInputField.classList.contains('--visible')) {
      e.preventDefault();
      fileInputField.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  const validFilesSize = () => {
    const sizeLimit = 7000000;
    //const sizeForMessage = `${(sizeLimit / 1000000).toFixed(1)} MB`
    let totalSize = 0;

    for (let i = 0; i < input.files.length ;i++) {
      totalSize += input.files[i].size;
    }

    if(sizeLimit < totalSize) {
      fileInputField.classList.add('--error');
      if(sizeError)sizeError.classList.remove('--hidden');
      input.form?.addEventListener('submit', preventDefault)

    } else {
      fileInputField.classList.remove('--error');
      if(sizeError)sizeError.classList.add('--hidden');
      input.form?.removeEventListener('submit', preventDefault)
    }
  };

  input.addEventListener("change", () => {
    if(!input.files) return;

    validFilesSize();

    let name = "";

    if (input.files.length > 1) name = `(${input.files.length}): `;

    for (let i = 0; i < input.files.length; i++) {
      const fileName = input.files[i].name;
      const maxLength = 10;
      const extensionIndex = fileName.lastIndexOf('.');
      const extension = fileName.slice(extensionIndex -1);
      let nameWithoutExtension = fileName.slice(0, extensionIndex -1);

      if (nameWithoutExtension.length > maxLength) {
        nameWithoutExtension = nameWithoutExtension.slice(0, maxLength) + '...';
      }

      name = name.concat(`${nameWithoutExtension + extension}, `);
    }

  changeInputValue(name);
})


removeElement?.addEventListener("click", (event) => {
  event.preventDefault();
  changeInputValue("");
  validFilesSize();
})

const changeInputValue = (value : string) => {
  let message = defaultMessage;

  if (value.length > 0) {
    message = value;
    removeElement?.classList.add("--visible");
  }

  else {
    input.value = "";
    removeElement?.classList.remove("--visible");
  }

  changeMessage(messageElement, message)
}

const changeMessage = (messageElement: HTMLElement, message: string) => {
  messageElement.textContent = message.replace(/^.*[\\\/]/, ''); //eslint-disable-line no-useless-escape
}
})
